// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2EzcJ","dragIcon":"SortableItem_dragIcon__2boQc","disabled":"SortableItem_disabled__3_MBt"};